module.exports = __webpack_public_path__ + "img/second-rule.998ca603.png";